module.exports = __webpack_public_path__ + "static/media/4Matic.a37dea82.png";